import AppLayout from "./AppLayout";
import { Route, Routes } from 'react-router-dom'
import OnlineOrders from "./screens/App/OnlineOrders";
import Orders from "./screens/App/Orders";
import Dashboard from "./screens/App/Dashboard";
import Login from "./screens/Auth/Login";
import AuthLayout from "./AuthLayout";
import ForgotPassword from "./screens/Auth/ForgotPassword";
import OrderPayment from "./screens/App/OrderPayment";
import ManagerDashboard from "./screens/App/ManagerDashboard";
import Products from "./screens/App/Products";
import ProtectedRoutes from "./ProtectedRoutes"; 
import Inventory from "./screens/App/Inventory/Inventory";
import Profile from "./screens/App/Profile";
import ResetPassword from "./screens/Auth/ResetPassword";
import ErrorScreen from "./screens/Auth/ErrorScreen";
import OrdersReport from "./screens/App/Reports/OrdersReport";
import CriticalStockReport from "./screens/App/Reports/CriticalStockReport";
import PaymentTransactions from "./screens/App/PaymentTransactions";
import CreateOrder from "./screens/App/CreateOrder";
import ComplimentaryOrder from "./screens/App/ComplimentaryOrder";
import ComplimentaryOrderPayment from "./screens/App/ComplimentaryOrderPayment";
import VerifyComplimentaryOrderPayment from "./screens/App/verifyComplimentaryOrderPayment";
import CustomerSupport from "./screens/App/CustomerSupport";
import HelpSupport from "./screens/App/HelpSupport";
import LocalStock from "./screens/App/Inventory/LocalStock";
import StockRequest from "./screens/App/Inventory/StockRequest";
import PettyCash from "./screens/App/Inventory/PettyCash";
import PettyCashTransactions from "./screens/App/Inventory/PettyCashTransactions";
import StockRequestsList from "./screens/App/Inventory/StockRequestsList";
import StockRequestDetails from "./screens/App/Inventory/StockRequestDetails";
import LocalStockListing from "./screens/App/Inventory/LocalStockListing";
import ConsumptionReport from "./screens/App/Reports/ConsumptionReport";
import ProductSales from "./screens/App/Reports/ProductSales";
import AddonSales from "./screens/App/Reports/AddonSales";
import OnlineItemSales from "./screens/App/Online-Sales/OnlineItemSales";
import OnlineOrderSales from "./screens/App/Online-Sales/OnlineOrderSales";
import OnlineSalesList from "./screens/App/Online-Sales/OnlineSalesList";
import DamagedMaterials from "./screens/App/DamagedMaterials/DamageMaterials";
import StockTransactionsReport from "./screens/App/Reports/StockTransactionsReport";
import DamageReport from "./screens/App/Reports/DamageReport";
import Offers from "./screens/App/Offers/Offers";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<AuthLayout />}>
                <Route path='/' element={<Login />} />
                <Route path='/forgotPassword' element={<ForgotPassword />} />
                <Route path='/resetPassword' element={<ResetPassword />} />
            </Route>
            <Route path='/' element={<AppLayout />}>
                <Route element={<ProtectedRoutes />}>
                    <Route path='/onlineOrders' element={<OnlineOrders />} />
                    <Route path='/orders' element={<Orders />} />
                    <Route path='/profile' element={<Profile />} />
                    <Route path='/orderPayment' element={<OrderPayment />} />
                    <Route path='/products' element={<Products />} />
                    <Route path='/dashboard' element={<Dashboard />} />
                    <Route path='/managerDashboard' element={<ManagerDashboard />} />
                    <Route path='/inventory' element={<Inventory />} />
                    <Route path='/stock-transactions-report' element={<StockTransactionsReport />} />
                    <Route path='/ordersReport' element={<OrdersReport />} />
                    <Route path='/criticalReport' element={<CriticalStockReport />} />
                    <Route path='/paymentTransactions' element={<PaymentTransactions />} />
                    <Route path='/createOrder' element={<CreateOrder />} />
                    <Route path='/complimentaryOrder' element={<ComplimentaryOrder />} />
                    <Route path='/complimentaryOrderPayment' element={<ComplimentaryOrderPayment />} />
                    <Route path='/verifyComplimentaryOrderPayment' element={<VerifyComplimentaryOrderPayment />} />
                    <Route path='/customerSupport' element={<CustomerSupport />} />
                    <Route path='/helpSupport' element={<HelpSupport />} />
                    <Route path='/outlet-offers' element={<Offers />} />
                    <Route path='/local-stock' element={<LocalStock />} />
                    <Route path='/stockRequest' element={<StockRequest />} />
                    <Route path='/petty-cash' element={<PettyCash />} />
                    <Route path='/petty-cash-transactions' element={<PettyCashTransactions />} />
                    <Route path='/stock-requistion-requests' element={<StockRequestsList />} />
                    <Route path='/stock-requistion-details' element={<StockRequestDetails />} />
                    <Route path='/local-stock-listing' element={<LocalStockListing />} />
                    <Route path="/stock-consumption" element={<ConsumptionReport />} />
                    <Route path="/product-sales-report" element={<ProductSales />} />
                    <Route path="/addon-sales-report" element={<AddonSales />} />
                    <Route path="/online-items-sales" element={<OnlineItemSales />} />
                    <Route path="/online-order-sales" element={<OnlineOrderSales />} />
                    <Route path="/online-sales-list" element={<OnlineSalesList />} />
                    <Route path='/damaged-materials' element={<DamagedMaterials />} />
                    <Route path='/damaged-report' element={<DamageReport />} />
                </Route>
            </Route>
            <Route path='/errorScreen' element={<ErrorScreen />} />
        </Routes>
    )
}

export default AppRoutes;